module.exports = __webpack_public_path__ + "assets/redpack-meteor-front-2-3a7d059b.png";